import { render } from "./faqClientViev.vue?vue&type=template&id=1105fcd4&scoped=true"
import script from "./faqClientViev.vue?vue&type=script&lang=js"
export * from "./faqClientViev.vue?vue&type=script&lang=js"

import "./faqClientViev.vue?vue&type=style&index=0&id=1105fcd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1105fcd4"

export default script